import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["element-loading-text"]
const _hoisted_2 = { class: "fc-d" }

import { ref, reactive, unref } from 'vue';
import { ElMessage } from 'element-plus';
import { formatTools } from '@/utils';
import { PayPlanDetailApi } from '@/apis/PayPlans/payplan.api';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { fAmount, fDateTime, fDate, fScale } = formatTools();

// 获取翻译函数
const { t } = useLocales();

const state = reactive({
	show: false,
	title: t('payplanDetail.title', '付款计划详细'),
	loading: false,
	detail: {} as any,
});

const load = {
	/* 获取付款计划明细 */
	getDetail: (planId: string) => {
		state.loading = true;

		PayPlanDetailApi(planId)
			.then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`读取付款计划出错，可能的原因是：${res.errors}。`);
				} else {
					state.detail = res.data;
				}
			})
			.finally(() => {
				state.loading = false;
			});
	},
};

const expFuncs = {
	openDialog: (planId: string) => {
		load.getDetail(planId);
		state.show = true;
	},
};

expose({ ...expFuncs });

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    width: "860"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('payplanDetail.buttons.close', '关闭')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        "element-loading-text": _unref(t)('payplanDetail.loading', '正在获取数据，请稍后')
      }, [
        _createVNode(_component_el_descriptions, {
          column: "2",
          border: true,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('bill.planName', '款项名称'),
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.name), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('bill.planCondition', '款项条件'),
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.pay_condition || '--'), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.remark', '备注'),
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.remark || '--'), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('bill.expectedDate', '预计付款日期'),
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(fDate)(_unref(state).detail.pay_date, _unref(t)('bill.expectedDate', '未定'))), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('bill.payType', '付款类型'),
              "label-align": "left",
              span: "1"
            }, {
              default: _withCtx(() => [
                (_unref(state).detail.is_split == 0)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('bill.paymentPending', '待定')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(state).detail.is_split == 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('bill.splitPayment', '分批付款')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(state).detail.is_split == 2)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "success",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('bill.fullPayment', '全部付款')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.billInfo.approvalStatus', '状态'),
              "label-align": "left",
              span: "1"
            }, {
              default: _withCtx(() => [
                (_unref(state).detail.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('bill.unpaid', '未付款')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(state).detail.status == 2)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('bill.paying', '付款中')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(state).detail.status == 3)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "success",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('bill.paid', '付款完成')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('bill.applyAmount', '款项金额'),
              "label-align": "left",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(fAmount)(_unref(state).detail.amount)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('performs.table.planScale', '款项比例'),
              "label-align": "left",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(fScale)(_unref(state).detail.scale)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('bill.unpayAmount', '未付金额'),
              "label-align": "left",
              width: "250"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(fAmount)(_unref(state).detail.unpay_amt)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('bill.auditAmount', '待审批金额'),
              "label-align": "left",
              width: "250"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(fAmount)(_unref(state).detail.audit_amt)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('performs.table.unpaidAmount', '待支付金额'),
              "label-align": "left",
              width: "250"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(fAmount)(_unref(state).detail.wait_amt)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('bill.paidAmount', '已支付金额'),
              "label-align": "left",
              width: "250"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(fAmount)(_unref(state).detail.isPay_amt)), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ], 8, _hoisted_1)), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})